// Complete File updated by Imran Khan on 27 April 2026
import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Table,
  Form,
  Modal,
  FormGroup,
  FormLabel,
} from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import Select from "react-select";

import { Link, useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { ROUTES } from "../../constants/webRouting";
import DateRangePicker from 'rsuite/DateRangePicker';
// (Optional) Import component styles. If you are using Less, import the `index.less` file. 
import 'rsuite/DateRangePicker/styles/index.css';
import ".././../assets/css/ListComponentsTable.css";
import {
  formatDate,
  formatDateForView,
  getUserDetails,
} from "../../utils/helper";
import * as constants from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";
import UserMultiSelect from "../common/UserMultiSelect";
import moment from "moment";//Added by shahir hussain 31-12-2025
import PubSub from "pubsub-js";

/* ─── Inline Responsive Styles ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Space+Grotesk:wght@400;500;600;700&display=swap');

  * { box-sizing: border-box; }

  .amc-root {
    background: #f0f4f9;
    min-height: 100vh;
    padding: 20px 16px;
    font-family: 'DM Sans', sans-serif;
  }

  /* ── Page Header ── */
  .amc-page-title { font-size: 20px; font-weight: 600; color: #1a1d23; margin-bottom: 2px; font-family: 'Space Grotesk', sans-serif; }
  .amc-breadcrumb { font-size: 12px; color: #9098a9; margin-bottom: 3px; }
  .amc-breadcrumb a { color: #378ADD; text-decoration: none; }
  .amc-page-desc { font-size: 12px; color: #b0b8c8; margin-bottom: 20px; }

  /* ── Stat Cards Grid ── */
  .amc-stat-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px;
    margin-bottom: 20px;
  }
  @media (max-width: 1400px) { .amc-stat-grid { grid-template-columns: repeat(3, 1fr); } }
  @media (max-width: 768px)  { .amc-stat-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; } }
  @media (max-width: 480px)  { .amc-stat-grid { grid-template-columns: 1fr 1fr; gap: 8px; } }

  /* ── Stat Card ── */
  .amc-stat-card {
    background: #fff;
    border: 1px solid #e8edf5;
    border-radius: 14px;
    padding: 14px 14px 10px;
    cursor: pointer;
    transition: box-shadow .18s, transform .18s, border-color .18s;
    position: relative;
    overflow: hidden;
  }
  .amc-stat-card:hover {
    box-shadow: 0 6px 24px rgba(55,138,221,.13);
    transform: translateY(-2px);
    border-color: #c8d8ee;
  }
  .amc-stat-card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 3px;
    border-radius: 14px 14px 0 0;
    background: var(--accent-color, #378ADD);
    opacity: 0;
    transition: opacity .2s;
  }
  .amc-stat-card:hover::before { opacity: 1; }
  .amc-stat-icon {
    width: 34px; height: 34px; border-radius: 9px;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 10px;
  }
  .amc-stat-label { font-size: 10px; font-weight: 600; color: #9098a9; text-transform: uppercase; letter-spacing: .05em; margin-bottom: 4px; }
  .amc-stat-num { font-size: 22px; font-weight: 700; line-height: 1; margin-bottom: 3px; font-family: 'Space Grotesk', sans-serif; }
  .amc-stat-sub { font-size: 10px; color: #b0b8c8; }
  .amc-sparkline { margin-top: 8px; width: 100%; height: 26px; }

  /* ── Insights Section ── */
  .amc-insights-title {
    font-size: 13px; font-weight: 600; color: #1a1d23;
    margin-bottom: 12px; display: flex; align-items: center; gap: 7px;
    font-family: 'Space Grotesk', sans-serif;
  }

  /* ── Insights Grid ── */
  .amc-insights-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 20px;
  }
  @media (max-width: 1200px) { .amc-insights-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 640px)  { .amc-insights-grid { grid-template-columns: 1fr; } }

  /* ── Insight Card ── */
  .amc-insight-card {
    background: #fff;
    border: 1px solid #e8edf5;
    border-radius: 14px;
    overflow: hidden;
  }
  .amc-insight-card-head {
    padding: 11px 15px;
    font-size: 10px; font-weight: 700;
    color: #9098a9; text-transform: uppercase;
    letter-spacing: .07em;
    border-bottom: 1px solid #f0f4f9;
    background: #fafbfd;
  }
  .amc-insight-card-body { padding: 14px 15px; }

  /* ── Filter Card ── */
  .amc-filter-card {
    background: #fff;
    border: 1px solid #e8edf5;
    border-radius: 14px;
    padding: 16px 18px;
    margin-bottom: 12px;
  }
  .amc-filter-label {
    font-size: 10px; font-weight: 700; color: #9098a9;
    text-transform: uppercase; letter-spacing: .05em;
    margin-bottom: 5px; display: block;
  }
  .amc-filter-select {
    border: 1px solid #dde3ef;
    border-radius: 8px; padding: 7px 10px;
    font-size: 12px; color: #333; background: #fff;
    width: 100%; outline: none;
    transition: border-color .15s;
    font-family: 'DM Sans', sans-serif;
  }
  .amc-filter-select:focus { border-color: #378ADD; }
  .amc-filter-select-wrapper { position: relative; }
  .amc-advanced-toggle {
    font-size: 12px; color: #378ADD; cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    margin-top: 10px; user-select: none; padding: 0;
    background: none; border: none; font-family: 'DM Sans', sans-serif;
    transition: opacity .15s;
  }
  .amc-advanced-toggle:hover { opacity: .75; }

  /* ── Buttons ── */
  .amc-btn-primary {
    background: #378ADD; border: none; border-radius: 8px;
    padding: 7px 14px; font-size: 12px; color: #fff;
    cursor: pointer; font-weight: 600; display: inline-flex;
    align-items: center; gap: 5px; white-space: nowrap;
    transition: background .15s, transform .12s;
    font-family: 'DM Sans', sans-serif;
  }
  .amc-btn-primary:hover { background: #2a6eb8; transform: translateY(-1px); }
  .amc-btn-secondary {
    background: #f0f4f9; border: 1px solid #dde3ef; border-radius: 8px;
    padding: 7px 12px; font-size: 12px; color: #555; cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px; white-space: nowrap;
    transition: background .15s; font-family: 'DM Sans', sans-serif;
  }
  .amc-btn-secondary:hover { background: #e0e8f4; }

  /* ── Table Card ── */
  .amc-table-card {
    background: #fff; border: 1px solid #e8edf5;
    border-radius: 14px; overflow: hidden; margin-bottom: 12px;
  }
  .amc-table-head {
    display: flex; align-items: center; justify-content: space-between;
    padding: 13px 18px; border-bottom: 1px solid #f0f4f9;
    flex-wrap: wrap; gap: 8px;
  }
  .amc-table-title { font-size: 14px; font-weight: 600; color: #1a1d23; font-family: 'Space Grotesk', sans-serif; }
  .amc-table-count { font-size: 12px; color: #9098a9; font-weight: 400; margin-left: 4px; }
  .amc-table-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
  .amc-table-foot {
    padding: 10px 18px;
    border-top: 1px solid #f0f4f9;
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 8px;
  }
  .amc-table-foot-text { font-size: 12px; color: #9098a9; }

  /* ── Progress Bar ── */
  .amc-progress-track { height: 5px; background: #f0f4f9; border-radius: 3px; }
  .amc-progress-fill { height: 5px; border-radius: 3px; transition: width .4s ease; }

  /* ── Donut ── */
  .amc-donut-wrap { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }

  /* ── Retention row ── */
  .amc-retention-row {
    display: flex; align-items: center; gap: 10px;
    padding: 8px 0; border-bottom: 1px solid #f0f4f9;
    cursor: pointer; transition: background .12s;
    border-radius: 6px; padding-left: 4px;
  }
  .amc-retention-row:hover { background: #f7fafd; }
  .amc-retention-row:last-child { border-bottom: none; }

  /* ── Legend pill ── */
  .amc-legend-pill {
    font-size: 10px; font-weight: 600; padding: 2px 7px;
    border-radius: 999px; white-space: nowrap;
  }

  /* ── Filter Row responsive ── */
  .amc-filter-row { display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-end; }
  .amc-filter-col { min-width: 120px; flex: 1 1 120px; }
  .amc-filter-col-lg { min-width: 180px; flex: 2 1 180px; }
  .amc-filter-col-sm { min-width: 90px; flex: 1 1 90px; }
  .amc-filter-actions { display: flex; gap: 6px; flex-wrap: wrap; align-items: flex-end; flex: 0 0 auto; }

  @media (max-width: 576px) {
    .amc-filter-col, .amc-filter-col-lg, .amc-filter-col-sm { flex: 1 1 100%; }
    .amc-filter-actions { width: 100%; }
    .amc-table-head { padding: 10px 12px; }
    .amc-filter-card { padding: 12px; }
    .amc-insight-card-body { padding: 10px 12px; }
    .amc-stat-num { font-size: 18px; }
    .amc-stat-card { padding: 12px 10px 8px; }
  }
`;

const STATUS_CONFIG = [
  {
    label: "AMC Running",
    color: "#1D9E75",
    iconBg: "#E1F5EE",
    iconColor: "#0F6E56",
    fa: "fa-solid fa-circle-check",
  },
  {
    label: "Due",
    color: "#E24B4A",
    iconBg: "#FCEBEB",
    iconColor: "#A32D2D",
    fa: "fa-solid fa-triangle-exclamation",
  },
  {
    label: "Pending",
    color: "#EF9F27",
    iconBg: "#FAEEDA",
    iconColor: "#854F0B",
    fa: "fa-solid fa-clock",
  },
  {
    label: "Done",
    color: "#378ADD",
    iconBg: "#E6F1FB",
    iconColor: "#185FA5",
    fa: "fa-solid fa-check-double",
  },
  {
    label: "Warranty",
    color: "#7F77DD",
    iconBg: "#EEEDFE",
    iconColor: "#534AB7",
    fa: "fa-solid fa-shield-halved",
  },
  {
    label: "Not Done",
    color: "#D85A30",
    iconBg: "#FAECE7",
    iconColor: "#993C1D",
    fa: "fa-solid fa-circle-xmark",
  },
  {
    label: "Lost",
    color: "#888780",
    iconBg: "#F1EFE8",
    iconColor: "#5F5E5A",
    fa: "fa-solid fa-ban",
  },
  {
    label: "One Time",
    color: "#D4537E",
    iconBg: "#FBEAF0",
    iconColor: "#993556",
    fa: "fa-solid fa-calendar-day",
  },
  {
    label: "Advance Order",
    color: "#639922",
    iconBg: "#EAF3DE",
    iconColor: "#3B6D11",
    fa: "fa-solid fa-rocket",
  },
];

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/* ── Sparkline ── */
const Sparkline = ({ color, points }) => (
  <svg
    className="amc-sparkline"
    viewBox="0 0 120 26"
    preserveAspectRatio="none"
  >
    <polyline
      points={points}
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ── Stat Card ── */
const StatCard = ({
  icon,
  iconBg,
  iconColor,
  label,
  num,
  numColor,
  sub,
  sparkColor,
  sparkPoints,
  onClick,
  accentColor,
}) => (
  <div
    className="amc-stat-card"
    style={{ "--accent-color": accentColor || numColor || "#378ADD" }}
    onClick={onClick}
  >
    <div className="amc-stat-icon" style={{ background: iconBg }}>
      <i className={icon} style={{ fontSize: 14, color: iconColor }}></i>
    </div>
    <div className="amc-stat-label">{label}</div>
    <div className="amc-stat-num" style={{ color: numColor || "#1a1d23" }}>
      {num}
    </div>
    <div className="amc-stat-sub">{sub}</div>
    {sparkPoints && <Sparkline color={sparkColor} points={sparkPoints} />}
  </div>
);

/* ── Donut Chart ── */
const DonutChart = ({ data, total }) => {
  const r = 48,
    cx = 56,
    cy = 56,
    circ = 2 * Math.PI * r;
  let offset = 0;
  const slices = data.map((d) => {
    const pct = total > 0 ? d.count / total : 0;
    const dash = pct * circ;
    const slice = { ...d, dash, offset, pct };
    offset += dash;
    return slice;
  });
  return (
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      style={{ flexShrink: 0 }}
    >
      <circle
        cx={cx}
        cy={cy}
        r={r}
        fill="none"
        stroke="#f0f4f9"
        strokeWidth="14"
      />
      {slices.map((s, i) => (
        <circle
          key={i}
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke={s.color}
          strokeWidth="14"
          strokeDasharray={`${s.dash} ${circ - s.dash}`}
          strokeDashoffset={circ / 4 - s.offset}
        />
      ))}
      <text
        x={cx}
        y={cy - 5}
        textAnchor="middle"
        fontSize="15"
        fontWeight="700"
        fill="#1a1d23"
        fontFamily="'Space Grotesk', sans-serif"
      >
        {total.toLocaleString("en-IN")}
      </text>
      <text x={cx} y={cy + 10} textAnchor="middle" fontSize="8" fill="#9098a9">
        TOTAL
      </text>
    </svg>
  );
};

const OrderAmcList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();

  const [body, setBody] = useState();
  const [dateRange, setDateRange] = useState([]);
  const [amcUptoDateRange, setAmcUptoDateRange] = useState([]);
  const [filterData, setFilterData] = useState({ amc_status: "AMC Running" });
  const [orderValues, setOrderValues] = useState([]);
  const [statusArray] = useState(constants.AMC_STATUS_VALUES);
  const [assignUsers, setAssignUsers] = useState([]);
  const [endDateYear, setEndDateYear] = useState("");
  const [endDateMonth, setEndDateMonth] = useState("");
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [changeOwnerModal, setChangeOwnerModal] = useState(false);
  const [refreshRecords, setRefreshRecords] = useState(false);
  const [ownerLeads, setOwnerLeads] = useState([]);
  const [ownerLeadsHeader, setOwnerLeadsHeader] = useState([]);
  const [fromUser, setFromUser] = useState({});
  const tableRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [spinnerForChangeOwner, setSpinnerForChangeOwner] = useState(false);
  const [selectedToUsers, setSelectedToUsers] = useState([]);

  const filteredBody = useMemo(() => {
    if (!body || !Array.isArray(body)) return body;
    return body.filter((row) => {
      if (!row.end_date) return true;
      const d = new Date(row.end_date);
      if (isNaN(d)) return true;
      if (endDateYear && d.getFullYear().toString() !== endDateYear)
        return false;
      if (endDateMonth && (d.getMonth() + 1).toString() !== endDateMonth)
        return false;
      return true;
    });
  }, [body, endDateYear, endDateMonth]);

  const total = filteredBody?.length || 0;

  const statusCounts = useMemo(() => {
    if (!filteredBody || !Array.isArray(filteredBody)) return {};
    return filteredBody.reduce((acc, r) => {
      acc[r.amc_status] = (acc[r.amc_status] || 0) + 1;
      return acc;
    }, {});
  }, [filteredBody]);

  const statusCards = useMemo(
    () =>
      STATUS_CONFIG.filter((c) => statusCounts[c.label])
        .map((c) => ({ ...c, count: statusCounts[c.label] }))
        .sort((a, b) => b.count - a.count),
    [statusCounts],
  );

  const activeCount = statusCounts["AMC Running"] || 0;
  const pendingCount = statusCounts["Pending"] || 0;
  const dueCount = statusCounts["Due"] || 0;
  const advanceCount = statusCounts["Advance Order"] || 0;
  const doneCount = statusCounts["Done"] || 0;
  const lostCount = statusCounts["Lost"] || 0;
  const totalRevenue = useMemo(() => {
    if (!body || !Array.isArray(body)) return 0;

    return body.reduce((sum, r) => {
      // amc_total_amount ko float mein convert karein
      // Replace logic: agar value string hai toh commas wagera saaf karein
      const price =
        typeof r.amc_total_amount === "string"
          ? parseFloat(r.amc_total_amount.replace(/,/g, ""))
          : parseFloat(r.amc_total_amount);

      return sum + (isNaN(price) ? 0 : price);
    }, 0);
  }, [body]); // Yahan 'body' use karein taaki filters se revenue change na ho

  // City-wise top 5 calculation
  const cityData = useMemo(() => {
    if (!filteredBody || !Array.isArray(filteredBody)) return [];

    const counts = filteredBody.reduce((acc, r) => {
      if (r.city) {
        // 1. City name ko lowercase mein convert karein grouping ke liye
        const cityName = r.city.trim().toLowerCase();
        acc[cityName] = (acc[cityName] || 0) + 1;
      }
      return acc;
    }, {});

    return Object.entries(counts)
      .sort((a, b) => b[1] - a[1]) // High to low sort
      .slice(0, 5) 
      .map(([city, count]) => ({
        // 2. Display ke liye first letter capitalize karein (e.g., jaipur -> Jaipur)
        city: city.charAt(0).toUpperCase() + city.slice(1),
        count,
      }));
  }, [filteredBody]);

  const paymentData = useMemo(() => {
    if (!filteredBody || !Array.isArray(filteredBody)) return {};
    return filteredBody.reduce((acc, r) => {
      if (r.payment_status)
        acc[r.payment_status] = (acc[r.payment_status] || 0) + 1;
      return acc;
    }, {});
  }, [filteredBody]);

  const partsData = useMemo(() => {
    if (!filteredBody || !Array.isArray(filteredBody)) return {};
    return filteredBody.reduce((acc, r) => {
      if (r.parts_type) acc[r.parts_type] = (acc[r.parts_type] || 0) + 1;
      return acc;
    }, {});
  }, [filteredBody]);

  const availableYears = useMemo(() => {
    if (!body || !Array.isArray(body)) return [];
    return [
      ...new Set(
        body
          .map((r) => {
            if (!r.end_date) return null;
            const d = new Date(r.end_date);
            return isNaN(d) ? null : d.getFullYear();
          })
          .filter(Boolean),
      ),
    ].sort((a, b) => b - a);
  }, [body]);

  useEffect(() => {
    const filter = { ...filterData };
    delete filter.owner_name;
    delete filter.offer_name_label;
    filter.owner_ids = filter?.owner_ids
      ?.filter((i) => i.value)
      ?.map((i) => i.value);
    if (Array.isArray(dateRange) && dateRange.length > 0)
      filter.date_range = {
        filed: "createddate",
        createddate: {
          from: formatDate(dateRange?.at(0)),
          to: formatDate(dateRange?.at(1)),
        },
      };
    if (Array.isArray(amcUptoDateRange) && amcUptoDateRange.length > 0)
      filter.amc_upto_range = {
        start_date: formatDate(amcUptoDateRange?.at(0)),
        end_date: formatDate(amcUptoDateRange?.at(1)),
      };
    fetchOrderAmcs(filter);
  }, [dateRange, filterData, amcUptoDateRange]);

  async function init() {
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some((p) =>
        userInfo?.permissions?.map((x) => x.name).includes(p),
      )
    ) {
      const r = await fuziElevatorsApi.fetchUsers();
      r &&
        Array.isArray(r) &&
        setAssignUsers(r.map((u) => ({ value: u.id, label: u.username })));
    }
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER].some((p) =>
        userInfo?.permissions?.map((x) => x.name).includes(p),
      )
    ) {
      fuziElevatorsApi.fetchOrders().then(
        (r) =>
          r &&
          Array.isArray(r) &&
          setOrderValues(
            r.map((i) => ({
              id: i?.id,
              name: `${i?.offer_name_label || ""}`,
            })),
          ),
      );
    }
  }

  async function fetchOrderAmcs(filters) {
    setBody((await fuziElevatorsApi.fetchOrderAmcs(filters)) || []);
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const u = await fuziElevatorsApi.fetchUsersForListPage();
        setUsers(
          Array.isArray(u)
            ? u.map(({ id, username, userrole }) => ({
                value: id,
                label: `${username} - ${userrole}`,
              }))
            : [],
        );
      } catch {
        setUsers([]);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (fromUser?.value) {
        setSpinnerForChangeOwner(true);
        const leads = await fuziElevatorsApi.getOrderAMCByStaffId(
          fromUser.value,
        );
        if (leads.success) {
          setOwnerLeads(leads.data);
          setOwnerLeadsHeader([
            {
              title: (
                <Form.Check
                  type="checkbox"
                  label="Select All"
                  name="all_leads"
                  onChange={handelCheckBox}
                />
              ),
              prop: "id",
              isFilterable: true,
              cell: (row) => (
                <Form.Check type="checkbox" id={`${row.id}`} name="leads" />
              ),
            },
            {
              title: "Order",
              prop: "offer_name_label",
              isFilterable: true,
              cell: (row) => (
                <Link to={"/order_amcs/" + row.id} state={row}>
                  {row.offer_name_label}
                </Link>
              ),
            },
            {
              title: "AMC Status",
              prop: "amc_status",
              isFilterable: true,
              isSortable: true,
            },
            {
              title: "Created Date",
              prop: "createddate",
              isSortable: true,
              isFilterable: true,
              cell: (row) => (
                <span>{moment(row.createddate).format("DD-MM-yyyy")}</span>
              ),
            },
          ]);
        } else {
          setOwnerLeads([]);
          setOwnerLeadsHeader([]);
        }
        setSpinnerForChangeOwner(false);
      } else {
        setOwnerLeads([]);
        setOwnerLeadsHeader([]);
      }
    })();
  }, [fromUser]);

  const handleChange = (e) =>
    setFilterData((p) => ({ ...p, [e.target.name]: e.target.value }));
  const handleClear = () => {
    setFilterData({});
    setAmcUptoDateRange([]);
    setEndDateYear("");
    setEndDateMonth("");
    fetchOrderAmcs();
  };
  const getStatusClass = (status) => {
    const s = constants.AMC_STATUS_VALUES.find((v) => v.label === status);
    return s ? s.css : {};
  };
  const customFilter = (rows, filters) =>
    rows.filter((row) =>
      Object.keys(filters).every((col) => {
        const fv = filters[col]?.toLowerCase() || "";
        if (!fv) return true;
        return (row[col]?.toString().toLowerCase() || "").includes(fv);
      }),
    );
  const handelChangeOwnerModalClose = () => {
    setChangeOwnerModal(false);
    setRefreshRecords((r) => !r);
    setOwnerLeads([]);
    setOwnerLeadsHeader([]);
    setFromUser({});
    setSelectedToUsers([]);
  };
  const ChangeOwner = (e) => {
    e.preventDefault();
    let leads = [...tableRef?.current?.querySelectorAll(`input[name='leads']`)]
      .filter((el) => el.checked)
      .map((el) => el.id);
    const toUsers = selectedToUsers.map((u) => u.value);
    (async () => {
      const result = await fuziElevatorsApi.ChangeOrderAMCOwner({
        fromUser: fromUser.value,
        toUser: toUsers,
        leads,
      });
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Transfer Owner",
          message: "Owner Transfer successfully",
        });
        setSelectedToUsers([]);
        handelChangeOwnerModalClose();
      } else
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Transfer Owner Error",
          message: "Some error occurred",
        });
    })();
  };
  const handelCheckBox = (e) =>
    [...tableRef.current.querySelectorAll(`input[name='leads']`)].forEach(
      (el) => {
        el.checked = e.target.checked;
      },
    );

  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Order",
        prop: "offer_name_label",
        isFilterable: true,
        isSortable: true,
        cell: (row) => (
          <Link to={`${ROUTES.ORDER_AMC.LIST}/${row.id}`} state={row}>
            {row.offer_name_label}
          </Link>
        ),
      },
      { title: "Site Address", prop: "site_address", isFilterable: true },
      { title: "City", prop: "city", isFilterable: true },
      { title: "Phone", prop: "phone", isFilterable: true },
      {
        title: "AMC Start Date",
        prop: "start_date",
        isFilterable: true,
        cell: (row) => formatDateForView(row.start_date),
      },
      {
        title: "AMC Upto",
        prop: "end_date",
        isFilterable: true,
        isSortable: true,
        cell: (row) => formatDateForView(row.end_date),
      },
      {
        title: "AMC Status",
        prop: "amc_status",
        isFilterable: true,
        isSortable: true,
        alignment: { horizontal: "center" },
        cell: (row) => (
          <span
            className="badge rounded-pill w-100"
            style={getStatusClass(row.amc_status)}
          >
            {row.amc_status}
          </span>
        ),
      },
      { title: "Parts Type", prop: "parts_type", isFilterable: true },
    );
    [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some((p) =>
      userInfo?.permissions?.map((x) => x.name).includes(p),
    ) &&
      header.push({
        title: "AMC Price",
        prop: "amc_total_amount",
        isFilterable: true,
      });
    header.push(
      { title: "Payment Status", prop: "payment_status", isFilterable: true },
      { title: "Payment Mode", prop: "payment_mode", isFilterable: true },
      {
        title: "Payment Frequency",
        prop: "payment_frequency",
        isFilterable: true,
      },
    );
  } else {
    header.push({
      title: "Info",
      prop: "offer_name_label",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.ORDER_AMC.LIST}/${row.id}`}
            state={row}
            style={{ width: "100%" }}
          >
            {row.offer_name_label}
          </Link>
          <span>
            <i className="fa-solid fa-phone"></i> {row.phone}
          </span>
        </div>
      ),
    });
  }

  const paymentColors = {
    Paid: "#1D9E75",
    Pending: "#EF9F27",
    Due: "#E24B4A",
    "Not Paid": "#888780",
  };
  const cityColors = ["#378ADD", "#1D9E75", "#EF9F27", "#7F77DD", "#D85A30"];

  return (
    <>
      <style>{styles}</style>
      <div className="amc-root">
        {/* ── Page Header ── */}
        <div className="amc-page-title">AMC Management</div>
        <div className="amc-breadcrumb">
          <a href="#">Dashboard</a> › AMC Management
        </div>
        <div className="amc-page-desc">
          Manage and track all Annual Maintenance Contracts
        </div>

        {/* ── Stat Cards ── */}
        <div className="amc-stat-grid">
          <StatCard
            icon="fa-solid fa-layer-group"
            iconBg="#E6F1FB"
            iconColor="#185FA5"
            label="Total AMC"
            num={total.toLocaleString("en-IN")}
            numColor="#1a1d23"
            sub="All Contracts"
            sparkColor="#378ADD"
            sparkPoints="0,22 20,17 40,20 60,12 80,15 100,7 120,11"
            accentColor="#378ADD"
          />
          <StatCard
            icon="fa-solid fa-circle-check"
            iconBg="#E1F5EE"
            iconColor="#0F6E56"
            label="Active AMC"
            num={activeCount.toLocaleString("en-IN")}
            numColor="#1D9E75"
            sub={`${total ? Math.round((activeCount / total) * 100) : 0}% of total`}
            sparkColor="#1D9E75"
            sparkPoints="0,20 20,15 40,17 60,9 80,11 100,4 120,8"
            accentColor="#1D9E75"
            onClick={() =>
              setFilterData((p) => ({ ...p, amc_status: "AMC Running" }))
            }
          />
          <StatCard
            icon="fa-solid fa-clock"
            iconBg="#FAEEDA"
            iconColor="#854F0B"
            label="Pending"
            num={pendingCount.toLocaleString("en-IN")}
            numColor="#EF9F27"
            sub={`${total ? Math.round((pendingCount / total) * 100) : 0}% of total`}
            sparkColor="#EF9F27"
            sparkPoints="0,16 20,20 40,14 60,18 80,12 100,16 120,10"
            accentColor="#EF9F27"
            onClick={() =>
              setFilterData((p) => ({ ...p, amc_status: "Pending" }))
            }
          />
          {/* <StatCard
            icon="fa-solid fa-triangle-exclamation"
            iconBg="#FCEBEB"
            iconColor="#A32D2D"
            label="Due / Overdue"
            num={dueCount.toLocaleString("en-IN")}
            numColor="#E24B4A"
            sub={`${total ? ((dueCount / total) * 100).toFixed(1) : 0}% of total`}
            sparkColor="#E24B4A"
            sparkPoints="0,22 20,22 40,20 60,22 80,20 100,18 120,14"
            accentColor="#E24B4A"
            onClick={() => setFilterData((p) => ({ ...p, amc_status: "Due" }))}
          /> */}
          <StatCard
            icon="fa-solid fa-rocket"
            iconBg="#EAF3DE"
            iconColor="#3B6D11"
            label="Advance Order"
            num={advanceCount.toLocaleString("en-IN")}
            numColor="#639922"
            sub="Upcoming contracts"
            sparkColor="#639922"
            sparkPoints="0,18 20,14 40,20 60,12 80,16 100,8 120,12"
            accentColor="#639922"
            onClick={() =>
              setFilterData((p) => ({ ...p, amc_status: "Advance Order" }))
            }
          />
          <StatCard
            icon="fa-solid fa-check-double"
            iconBg="#E6F1FB"
            iconColor="#185FA5"
            label="Done AMC"
            num={doneCount.toLocaleString("en-IN")}
            numColor="#378ADD"
            sub="Completed contracts"
            sparkColor="#378ADD"
            sparkPoints="0,22 20,16 40,18 60,10 80,12 100,6 120,9"
            accentColor="#378ADD"
            onClick={() => setFilterData((p) => ({ ...p, amc_status: "Done" }))}
          />
          <StatCard
            icon="rupiah-sign fa-solid fa-indian-rupee-sign"
            iconBg="#E6F1FB"
            iconColor="#185FA5"
            label="Total Revenue (Done AMC)"
            num={`₹ ${totalRevenue.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`}
            numColor="#378ADD"
            sub="Total value from database"
            sparkColor="#378ADD"
            sparkPoints="0,26 20,20 40,22 60,14 80,16 100,8 120,12"
          />
        </div>

        {/* ── AMC Insights ── */}
        {filteredBody && Array.isArray(filteredBody) && total > 0 && (
          <>
            <div className="amc-insights-title">
              <i
                className="fa-solid fa-chart-pie"
                style={{ color: "#378ADD", fontSize: 13 }}
              ></i>
              AMC Insights
            </div>
            <div className="amc-insights-grid">
              {/* Status Breakdown */}
              <div className="amc-insight-card">
                <div className="amc-insight-card-head">Status Breakdown</div>
                <div className="amc-insight-card-body">
                  <div className="amc-donut-wrap">
                    <DonutChart data={statusCards.slice(0, 6)} total={total} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {statusCards
                        .slice(0, 6)
                        .map(({ label, color, count }) => (
                          <div
                            key={label}
                            onClick={() =>
                              setFilterData((p) => ({
                                ...p,
                                amc_status: label,
                              }))
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 7,
                              fontSize: 11,
                              color: "#555",
                              marginBottom: 7,
                              cursor: "pointer",
                            }}
                          >
                            <span
                              style={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                background: color,
                                flexShrink: 0,
                              }}
                            ></span>
                            <span
                              style={{
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {label}
                            </span>
                            <strong
                              style={{
                                color: "#1a1d23",
                                fontFamily: "'Space Grotesk', sans-serif",
                              }}
                            >
                              {count.toLocaleString("en-IN")}
                            </strong>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Status */}
              <div className="amc-insight-card">
                <div className="amc-insight-card-head">Payment Status</div>
                <div className="amc-insight-card-body">
                  {Object.entries(paymentData)
                    .sort((a, b) => b[1] - a[1])
                    .map(([status, count]) => {
                      const pct =
                        total > 0 ? Math.round((count / total) * 100) : 0;
                      const c = paymentColors[status] || "#378ADD";
                      return (
                        <div key={status} style={{ marginBottom: 12 }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontSize: 12,
                              color: "#555",
                              marginBottom: 5,
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                              }}
                            >
                              <span
                                style={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: "50%",
                                  background: c,
                                  flexShrink: 0,
                                }}
                              ></span>
                              {status}
                            </span>
                            <span
                              style={{
                                fontWeight: 600,
                                color: "#1a1d23",
                                fontFamily: "'Space Grotesk', sans-serif",
                              }}
                            >
                              {count.toLocaleString("en-IN")}{" "}
                              <span
                                style={{ color: "#b0b8c8", fontWeight: 400 }}
                              >
                                ({pct}%)
                              </span>
                            </span>
                          </div>
                          <div className="amc-progress-track">
                            <div
                              className="amc-progress-fill"
                              style={{ width: `${pct}%`, background: c }}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>

              {/* Parts Type + Top Cities stacked on wide, or separate */}
              {/* <div className="amc-insight-card">
                <div className="amc-insight-card-head">Parts Type</div>
                <div className="amc-insight-card-body">
                  {Object.entries(partsData).map(([type, count]) => {
                    const pct =
                      total > 0 ? Math.round((count / total) * 100) : 0;
                    const c = type === "With Parts" ? "#378ADD" : "#7F77DD";
                    return (
                      <div key={type} style={{ marginBottom: 16 }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 6,
                          }}
                        >
                          <span style={{ fontSize: 12, color: "#555" }}>
                            {type}
                          </span>
                          <div style={{ textAlign: "right" }}>
                            <div
                              style={{
                                fontSize: 20,
                                fontWeight: 700,
                                color: c,
                                lineHeight: 1,
                                fontFamily: "'Space Grotesk', sans-serif",
                              }}
                              toLowerCase
                            >
                              {count.toLocaleString("en-IN")}
                            </div>
                            <div style={{ fontSize: 10, color: "#b0b8c8" }}>
                              {pct}%
                            </div>
                          </div>
                        </div>
                        <div
                          className="amc-progress-track"
                          style={{ height: 6 }}
                        >
                          <div
                            className="amc-progress-fill"
                            style={{
                              width: `${pct}%`,
                              background: c,
                              height: 6,
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div> */}
  
              {/* Top Cities */}
              {cityData.length > 0 && (
                <div className="amc-insight-card">
                  <div className="amc-insight-card-head">Top Cities</div>
                  <div className="amc-insight-card-body">
                    {cityData.map(({ city, count }, idx) => {
                      const pct =
                        cityData[0].count > 0
                          ? Math.round((count / cityData[0].count) * 100)
                          : 0;
                      const c = cityColors[idx];
                      return (
                        <div key={city} style={{ marginBottom: 10 }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontSize: 12,
                              color: "#555",
                              marginBottom: 4,
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                              }}
                            >
                              <span
                                className="amc-legend-pill"
                                style={{ color: c, background: c + "18" }}
                              >
                                #{idx + 1}
                              </span>
                              {city}
                            </span>
                            <strong
                              style={{
                                color: "#1a1d23",
                                fontFamily: "'Space Grotesk', sans-serif",
                              }}
                            >
                              {count}
                            </strong>
                          </div>
                          <div
                            className="amc-progress-track"
                            style={{ height: 4 }}
                          >
                            <div
                              className="amc-progress-fill"
                              style={{
                                width: `${pct}%`,
                                background: c,
                                height: 4,
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Retention Overview */}
              <div className="amc-insight-card">
                <div className="amc-insight-card-head">Retention Overview</div>
                <div
                  className="amc-insight-card-body"
                  style={{ padding: "8px 14px" }}
                >
                  {[
                    {
                      label: "Active",
                      count: activeCount,
                      color: "#1D9E75",
                      icon: "fa-solid fa-circle-check",
                    },
                    {
                      label: "Done",
                      count: doneCount,
                      color: "#378ADD",
                      icon: "fa-solid fa-check-double",
                    },
                    {
                      label: "Lost",
                      count: lostCount,
                      color: "#888780",
                      icon: "fa-solid fa-ban",
                    },
                    {
                      label: "Not Done",
                      count: statusCounts["Not Done"] || 0,
                      color: "#D85A30",
                      icon: "fa-solid fa-circle-xmark",
                    },
                  ].map(({ label, count, color, icon }) => (
                    <div
                      key={label}
                      className="amc-retention-row"
                      onClick={() =>
                        setFilterData((p) => ({ ...p, amc_status: label }))
                      }
                    >
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          background: color + "18",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <i className={icon} style={{ fontSize: 12, color }}></i>
                      </div>
                      <span style={{ flex: 1, fontSize: 12, color: "#555" }}>
                        {label}
                      </span>
                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: 700,
                          color,
                          fontFamily: "'Space Grotesk', sans-serif",
                        }}
                      >
                        {count.toLocaleString("en-IN")}
                      </span>
                      <span
                        style={{
                          fontSize: 10,
                          color: "#b0b8c8",
                          minWidth: 28,
                          textAlign: "right",
                        }}
                      >
                        {total > 0 ? Math.round((count / total) * 100) : 0}%
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}

        {/* ── Datatable ── */}
        <Container fluid style={{ padding: 0 }}>
          <DatatableWrapper
            body={
              filteredBody && Array.isArray(filteredBody) ? filteredBody : []
            }
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 50,
                options: [5, 10, 15, 20, 30, 50],
              },
            }}
            sortProps={{ initialState: { prop: "end_date", order: "asc" } }}
            filterFunction={customFilter}
          >
            {/* ── Filter Card ── */}
            <div className="amc-filter-card">
              <div className="amc-filter-row">
                <div className="amc-filter-col-lg">
                  <label className="amc-filter-label">Search</label>
                  <Filter
                    classes={{
                      inputGroup: "",
                      input: "",
                      clearButton: "btn-custom",
                    }}
                  />
                </div>
                <div className="amc-filter-col">
                  <label className="amc-filter-label">AMC Status</label>
                  <Form.Select
                    name="amc_status"
                    value={filterData?.amc_status || ""}
                    onChange={handleChange}
                    className="amc-filter-select"
                  >
                    <option value="">All Status</option>
                    {statusArray.map((item, i) => (
                      <option key={i} value={item.label}>
                        {item.label}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="amc-filter-col-sm">
                  <label className="amc-filter-label">Payment</label>
                  <Form.Select
                    name="payment_status"
                    value={filterData?.payment_status || ""}
                    onChange={handleChange}
                    className="amc-filter-select"
                  >
                    <option value="">All</option>
                    {["Pending", "Due", "Paid", "Not Paid"].map((v, i) => (
                      <option key={i} value={v}>
                        {v}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="amc-filter-col-sm">
                  <label className="amc-filter-label">AMC Year</label>
                  <Form.Select
                    value={endDateYear}
                    onChange={(e) => setEndDateYear(e.target.value)}
                    className="amc-filter-select"
                  >
                    <option value="">All Years</option>
                    {availableYears.map((y) => (
                      <option key={y} value={y.toString()}>
                        {y}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="amc-filter-col-sm">
                  <label className="amc-filter-label">AMC Month</label>
                  <Form.Select
                    value={endDateMonth}
                    onChange={(e) => setEndDateMonth(e.target.value)}
                    className="amc-filter-select"
                  >
                    <option value="">All Months</option>
                    {MONTHS.map((m, i) => (
                      <option key={i + 1} value={(i + 1).toString()}>
                        {m}
                      </option>
                    ))}
                  </Form.Select>
                </div>
                <div className="amc-filter-col-lg">
                  <label className="amc-filter-label">Assigned To</label>
                  <Select
                    isMulti
                    name="owner_ids"
                    classNamePrefix="react-select"
                    className="z-3"
                    onChange={(e) =>
                      handleChange({ target: { name: "owner_ids", value: e } })
                    }
                    value={filterData?.owner_ids?.filter((i) => i.value)}
                    options={assignUsers}
                    styles={{
                      control: (b) => ({
                        ...b,
                        fontSize: 12,
                        minHeight: 36,
                        borderRadius: 8,
                        borderColor: "#dde3ef",
                      }),
                    }}
                  />
                </div>
                <div className="amc-filter-col-sm">
                  <label className="amc-filter-label">Per Page</label>
                  <PaginationOptions labels={{ beforeSelect: " " }} />
                </div>
                <div className="amc-filter-actions">
                  <button className="amc-btn-secondary" onClick={handleClear}>
                    <i className="fa fa-refresh" style={{ fontSize: 10 }}></i>{" "}
                    Reset
                  </button>
                  {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_AMC].some((p) =>
                    userInfo?.permissions?.map((x) => x.name).includes(p),
                  ) && (
                    <button
                      className="amc-btn-primary"
                      onClick={() => navigate(ROUTES.ORDER_AMC.CREATE)}
                    >
                      <i
                        className="fa-solid fa-plus"
                        style={{ fontSize: 10 }}
                      ></i>{" "}
                      New AMC
                    </button>
                  )}
                  {userInfo?.userrole === "SUPER_ADMIN" && (
                    <button
                      className="amc-btn-primary"
                      style={{ background: "#7F77DD" }}
                      onClick={() => setChangeOwnerModal(true)}
                    >
                      <i
                        className="fa-solid fa-shuffle"
                        style={{ fontSize: 10 }}
                      ></i>{" "}
                      Transfer
                    </button>
                  )}
                </div>
              </div>

              <button
                className="amc-advanced-toggle"
                onClick={() => setShowAdvanced((p) => !p)}
              >
                <i
                  className={`fa-solid fa-chevron-${showAdvanced ? "down" : "right"}`}
                  style={{ fontSize: 9 }}
                ></i>
                Advanced Filters
              </button>

              {showAdvanced && (
                <div className="amc-filter-row" style={{ marginTop: 12 }}>
                  <div className="amc-filter-col-lg">
                    <label className="amc-filter-label">Order</label>
                    <Select
                      placeholder="Select Order"
                      classNamePrefix="react-select"
                      className="z-3"
                      options={orderValues.map((i) => ({
                        value: i.id,
                        label: i.name,
                      }))}
                      onChange={(e) => {
                        handleChange({
                          target: { name: "order_id", value: e.value },
                        });
                        handleChange({
                          target: { name: "offer_name_label", value: e.label },
                        });
                      }}
                      value={
                        filterData?.order_id
                          ? {
                              value: filterData.order_id,
                              label: filterData.offer_name_label,
                            }
                          : ""
                      }
                      styles={{
                        control: (b) => ({
                          ...b,
                          fontSize: 12,
                          minHeight: 36,
                          borderRadius: 8,
                          borderColor: "#dde3ef",
                        }),
                      }}
                    />
                  </div>
                  <div className="amc-filter-col">
                    <label className="amc-filter-label">Parts Type</label>
                    <Form.Select
                      name="parts_type"
                      value={filterData?.parts_type || ""}
                      onChange={handleChange}
                      className="amc-filter-select"
                    >
                      <option value="">All Types</option>
                      {["With Parts", "Without Parts"].map((v, i) => (
                        <option key={i} value={v}>
                          {v}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="amc-filter-col">
                    <label className="amc-filter-label">Payment Mode</label>
                    <Form.Select
                      name="payment_mode"
                      value={filterData?.payment_mode || ""}
                      onChange={handleChange}
                      className="amc-filter-select"
                    >
                      <option value="">All Modes</option>
                      {[
                        "Monthly",
                        "Quarterly",
                        "Half Yearly",
                        "Yearly",
                        "One Time",
                      ].map((v, i) => (
                        <option key={i} value={v}>
                          {v}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="amc-filter-col">
                    <label className="amc-filter-label">
                      Payment Frequency
                    </label>
                    <Form.Select
                      name="payment_frequency"
                      value={filterData?.payment_frequency || ""}
                      onChange={handleChange}
                      className="amc-filter-select"
                    >
                      <option value="">All</option>
                      {constants?.PAYMENT_FREQUENCY_VALUES?.map((item, i) => (
                        <option key={i} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <div className="amc-filter-col-lg">
                    <label className="amc-filter-label">
                      Created Date Range
                    </label>
                    <DateRangePicker
                      value={dateRange}
                      onChange={(e) => setDateRange(e)}
                      character=" – "
                    />
                  </div>
                  <div className="amc-filter-col-lg">
                    <label className="amc-filter-label">AMC Upto Range</label>
                    <DateRangePicker
                      value={amcUptoDateRange}
                      onChange={(e) => setAmcUptoDateRange(e)}
                      character=" – "
                      placeholder="AMC Upto Range"
                    />
                  </div>
                </div>
              )}
            </div>

            {/* ── Table Card ── */}
            <div className="amc-table-card">
              <div className="amc-table-head">
                <div className="amc-table-title">
                  AMC Contracts{" "}
                  <span className="amc-table-count">
                    ({total.toLocaleString("en-IN")})
                  </span>
                </div>
              </div>
              <div className="amc-table-scroll table-scroll">
                <Table striped className="shadow-sm rounded">
                  <TableHeader
                    classes={{ th: "bg-custom text-white sticky-header" }}
                  />
                  {filteredBody && Array.isArray(filteredBody) ? (
                    <TableBody />
                  ) : (
                    <tbody>
                      <tr>
                        <td
                          colSpan={100}
                          align="center"
                          style={{ padding: 40 }}
                        >
                          <Spinner />
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
              <div className="amc-table-foot">
                <span className="amc-table-foot-text">
                  Total:{" "}
                  <strong style={{ color: "#1a1d23" }}>
                    {total.toLocaleString("en-IN")}
                  </strong>{" "}
                  records
                </span>
                <Pagination
                  classes={{
                    buttonGroup: "btn-custom",
                    button: "bg-custom border-white",
                  }}
                />
              </div>
            </div>
          </DatatableWrapper>
        </Container>

        {/* ── Transfer Owner Modal ── */}
        {changeOwnerModal && (
          <Modal
            show={changeOwnerModal}
            onHide={handelChangeOwnerModalClose}
            size="xl"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: 16,
                }}
              >
                Transfer Owner
              </Modal.Title>
            </Modal.Header>
            <Form onSubmit={ChangeOwner}>
              <Modal.Body>
                <Row className="gap-3">
                  <Col lg={12}>
                    <Row>
                      <Col lg={6} xs={12} className="mb-3 mb-lg-0">
                        <FormGroup>
                          <FormLabel style={{ fontSize: 12, fontWeight: 600 }}>
                            From
                          </FormLabel>
                          <Select
                            isClearable
                            options={users}
                            onChange={(e) => setFromUser(e || {})}
                            name="fromUser"
                            required
                            styles={{
                              control: (b) => ({
                                ...b,
                                fontSize: 12,
                                borderRadius: 8,
                                borderColor: "#dde3ef",
                              }),
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} xs={12}>
                        <FormGroup>
                          <UserMultiSelect
                            options={users}
                            value={selectedToUsers}
                            onChange={setSelectedToUsers}
                            label="To"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {fromUser && Object.keys(fromUser).length > 0 && (
                  <Container
                    style={{ height: "50vh", overflowY: "auto", marginTop: 16 }}
                  >
                    {!spinnerForChangeOwner ? (
                      <DatatableWrapper
                        body={ownerLeads}
                        headers={ownerLeadsHeader}
                      >
                        <Table striped className="data-table" ref={tableRef}>
                          <TableHeader />
                          <TableBody />
                        </Table>
                      </DatatableWrapper>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center mt-5">
                        <Spinner animation="border" variant="secondary" />
                      </div>
                    )}
                  </Container>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="success" type="submit">
                  Change
                </Button>
                <Button onClick={handelChangeOwnerModalClose} variant="light">
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        )}
      </div>
    </>
  );
};

export default OrderAmcList;